import { sendGaEvent } from './analytics';

const initializedDocs = new WeakSet<Document>();

export function initRelatedItemClickTracking(doc: Document = document): void {
  if (initializedDocs.has(doc)) return;
  initializedDocs.add(doc);

  const trackClick = (event: MouseEvent) => {
    if (event.defaultPrevented) return;
    if (!((event.type === 'click' && event.button === 0) || (event.type === 'auxclick' && event.button === 1))) return;

    const target = event.target instanceof Element ? event.target : null;
    const link = target?.closest('a[data-item-id][href]');
    if (!(link instanceof HTMLAnchorElement)) return;

    const placement = link.closest('[data-related-item-placement]')?.getAttribute('data-related-item-placement');
    if (placement !== 'cross_platform' && placement !== 'same_price_band') return;

    const sourceItemId = doc.querySelector('[data-item-detail-view]')?.getAttribute('data-item-id');
    const destinationItemId = link.getAttribute('data-item-id');
    if (!sourceItemId?.trim() || !destinationItemId?.trim() || sourceItemId === destinationItemId) return;
    if (link.getAttribute('href') !== `/items/${encodeURIComponent(destinationItemId)}`) return;

    sendGaEvent('related_item_click', {
      placement,
      source_item_id: sourceItemId,
      destination_item_id: destinationItemId,
    });
  };

  doc.addEventListener('click', trackClick);
  doc.addEventListener('auxclick', trackClick);
}
